<div class="contenedor-general">
  <div class="superior">
    <h1 mat-dialog-title class="title-dialog">{{titulo}}</h1>
    <div class="botones"> <!-- Botones de editar, cambiar clave y cerrar -->
      @if (data.IdUsuario) {
        <mat-icon color="primary" matTooltip="{{'cambio_contraseña' | translate}}" matTooltipClass="colortooltip" (click)="changePassword()">lock</mat-icon>
        <mat-icon color="primary" matTooltip="{{'modificar' | translate}}" matTooltipClass="colortooltip" (click)="modifyMode()">edit</mat-icon>
      }
      <mat-icon color="warn" matTooltip="{{'cerrar' | translate}}" (click)="onNoClick()" matTooltipClass="colortooltip">close</mat-icon>
    </div>
  </div>

  <div mat-dialog-content>
    @if (animacion) {
      <div class="animacion">
        <mat-grid-list cols="3" rowHeight="100px">
          <mat-grid-tile colspan="1" rowspan="1">
          </mat-grid-tile>
          <mat-grid-tile colspan="1" rowspan="1">
            <div>
              @if (cargando) {
                <mat-progress-spinner diameter=60 mode="indeterminate">
                </mat-progress-spinner>
              }
            </div>
          </mat-grid-tile>
          <mat-grid-tile colspan="1" rowspan="1">
          </mat-grid-tile>
        </mat-grid-list>
      </div>
    }

    <mat-slide-toggle color="primary" class="slideAdministrar" [(ngModel)]="data.Activo" disabled>{{'activo' | translate}}</mat-slide-toggle>
    <br>
      <mat-form-field class="mat" appearance="outline">
        <mat-label>{{'nombreMostrar' | translate}}</mat-label>
        <input matInput [(ngModel)]="data.Nombre" [readonly]='modificar'>
      </mat-form-field>
      <mat-form-field class="mat" appearance="outline">
        <mat-label>{{'correo' | translate}}</mat-label>
        <input matInput [(ngModel)]="data.Email" [readonly]='modificar'>
      </mat-form-field>
      <mat-form-field class="mat" appearance="outline">
        <mat-label>{{mensajeUsuario}}</mat-label>
        <input matInput id="user" [formControl]="stateCtrlUsuario" [(ngModel)]="data.Usuario" [readonly]='modificar'>
      </mat-form-field>
    </div>
  </div>